export const ExitStatusValues = ['Finished', 'REL', 'DNC', 'DNF', 'DSQ', 'DNS', 'DNQ', 'LAP', 'None'] as const;
export type ExitStatus = (typeof ExitStatusValues)[number];
